import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import { logError } from './lib/firebase/logs';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<ErrorBoundary>
		<App />
	</ErrorBoundary>
);

reportWebVitals();

window.addEventListener('error', (e) => {
	logError(e.error || new Error(e.message));
});

window.addEventListener('unhandledrejection', (e) => {
	logError(e.reason instanceof Error ? e.reason : new Error(String(e.reason)));
});
